// NPM Requirements
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import MapListItem from './MapListItem';

import styles from './MapMarker.module.postcss';

class MapMarkerHover extends PureComponent {
  render() {
    const { hoverSide, location, onClose } = this.props;
    return (
      <div
        className={cn({
          [styles.MapMarker_hover]: true,
          [styles.MapMarker_hover__visible]: true,
          [styles.MapMarker_hover__interact]: true,
          [styles.MapMarker_hover__left]: (hoverSide === 'left'),
          [styles.MapMarker_hover__right]: (hoverSide === 'right'),
        })}
      >
        <MapListItem
          location={location}
          onClose={onClose}
        />
      </div>
    );
  }
}

MapMarkerHover.propTypes = {
  hoverSide: PropTypes.string,
  location: PropTypes.object,
  onClose: PropTypes.func,
};

export default MapMarkerHover;
